import {BasketTracker} from '@aboutyou/grpc-clients/tadarida/aysa_api/models//tracker.types';
import {
  TrackingBasicElementContext,
  TrackingBasketItemWithoutPrices,
  trackBasketAction,
} from '@aboutyou/legacy-tracking-sdk';
import {ProductTrackingData} from '../trackerComponents/TrackPromotions';
import {getSections} from '../utils/trackingProductGetter';
import {useTracking} from '../utils/utils';

/**
 * @deprecated Use the new useTrackNewBasketAction instead.
 */
export const useTrackBasketAction = () => {
  const {TrackingClient, pageContextCallback} = useTracking();

  return ({
    type,
    basketItem,
    trackingData,
    basketTracker,
    badges,
  }: {
    type: 'add-to-basket' | 'quantity-update' | 'removed-from-basket';
    basketItem: TrackingBasketItemWithoutPrices;
    basketTracker: BasketTracker;
    trackingData?: ProductTrackingData;
    badges: string[];
  }) => {
    const {section} = getSections({
      pageType: pageContextCallback().type,
      elements: trackingData?.elements,
      headline: trackingData?.headline,
      recoType: trackingData?.recoType,
      sectionIndex: trackingData?.sectionIndex,
      sortChannel: trackingData?.sortingChannel,
      streamPosition: trackingData?.streamPosition || 0,
    });
    const elementData = {
      type: 'element-context',
      rowIndexInSection: 1,
      columnIndexInSection: 1,
      elementIndexInSection: trackingData?.streamPosition || 0,
      productIndexOnPage: 1,
    } as TrackingBasicElementContext;

    TrackingClient.track(
      trackBasketAction({
        type,
        section,
        element: elementData,
        basketItem,
        basketTracker,
        badges,
      }),
    );
  };
};
